import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Checkbox } from 'components/atoms/checkbox';
import { DatePicker } from 'components/atoms/date-picker';
import { Form } from 'components/atoms/form';
import { Modal as ModalAtom } from 'components/atoms/modal';
import {
  Caption01,
  ProductiveHeading07,
  SingleLineEllipsis,
} from 'components/styles';

const PrimaryTitle = styled.div`
  ${ProductiveHeading07};
`;
const SecondaryTitle = styled.div`
  ${Caption01};
  ${SingleLineEllipsis};
  opacity: 0.5;
`;

interface Props {
  projectName: string;
}
export const Title: FC<Props> = ({ projectName }) => {
  return (
    <>
      <PrimaryTitle>
        <FormattedMessage id="resource_management.shift_start_date.title" />
      </PrimaryTitle>
      <SecondaryTitle>{projectName}</SecondaryTitle>
    </>
  );
};

export const Modal = styled(ModalAtom)`
  .ant-modal-header {
    background: var(--coolest-gray-10);
  }
`;
export const StyledForm = styled(Form)`
  display: flex;
  gap: var(--spacing-05);
  ${Form.Item} {
    flex: 1;
  }
  ${DatePicker} {
    width: 100%;
  }
`;
export const WarnText = styled.div`
  ${Caption01};
  color: var(--gray-70);
`;
export const ContentWrapper = styled.div`
  ${WarnText} {
    margin-top: calc(var(--spacing-07) * -1);
    margin-bottom: var(--spacing-07);
  }
`;
export const StaticContentWrapper = styled.div`
  margin: var(--spacing-05) 0;
  display: flex;
  gap: var(--spacing-02);
`;
export const StyledCheckbox = styled(Checkbox)`
  display: flex;
  align-items: center;
`;
